import React, { useEffect, useState } from 'react';
import { deleteAdvice, saveAdvice } from '../../API/advices';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { Check, Save, Trash2, X } from 'react-feather';
import '../../Styles/Annotator/AdvicesComponent.css';
import '../../Styles/Annotator/EditAdviceComponent.css';
import { getAdviceDB, removeAdviceDB, setAdviceDB } from '../../Database/AdvicesDAO';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Multiselect } from 'multiselect-react-dropdown';
import { getKategoriesDataAPI } from '../../API/kategories';

function EditAdviceComponent() {
    const [showEditAdviceModal, setShowEditAdviceModal] = useState(false);
    const [displayOtherFields, setDisplayOtherFields] = useState(false);
    const [editAdviceSaveConfirmationModalShow, setEditAdviceSaveConfirmationModalShow] = useState(false);
    const [editAdviceDeleteConfirmationModalShow, setEditAdviceDeleteConfirmationModalShow] = useState(false);
    const [editAdviceData, setEditAdviceData] = useState({
        advice: '',
        anspruch: '',
        category: 'Hinweis',
        pcategories: [],
        formel: '',
        kommentor: '',
        norm: '',
        uidid: ''
    });
    const [inputAdviceId, setInputAdviceId] = useState('');
    const handleAdviceIdChange = (event) => {
        setInputAdviceId(event.target.value);
    };
    const [pcategories, setPcategories] = useState([]);

    function onClose() {
        setShowEditAdviceModal(false);
        setDisplayOtherFields(false);
        setInputAdviceId('');
        setEditAdviceData({
            advice: '',
            anspruch: '',
            category: 'Hinweis',
            pcategories: [],
            formel: '',
            kommentor: '',
            norm: '',
            uidid: ''
        });
    }

    /**
     * This function handles the Edit button click and retains the original state of Advice data for API delete call.
     * @param adviceID
     */
    function handleEditClick(adviceID) {
        if (adviceID !== undefined) {
            getAdviceDB(adviceID).then((result) => {
                if (result.length !== 0) {
                    setEditAdviceData(result[0].data);
                    setDisplayOtherFields(true);
                } else {
                    alert('Please give proper advice ID');
                }
            });
        } else {
            alert('Please give proper advice ID');
        }
    }

    /**
     * This function handles the maintenance of new advice data for API.
     */
    function handleSave() {
        setEditAdviceSaveConfirmationModalShow(true);
    }

    /**
     * This function closes the Save confirmation model and calls API to save new advice.
     */
    async function handleSaveConfirmationClick() {
        let processedAdviceDataForAPI = {
            //advices: [
                //{
                    advice: editAdviceData.advice,
                    anspruch: editAdviceData.anspruch,
                    category: editAdviceData.category,
                    pcategories: editAdviceData.pcategories,
                    formel: editAdviceData.formel,
                    kommentor: editAdviceData.kommentor,
                    norm: editAdviceData.norm,
                    uidid: editAdviceData.uidid
              //  }
            //]
        };
        setEditAdviceSaveConfirmationModalShow(false);
        await saveAdvice(processedAdviceDataForAPI); //  API call
        setAdviceDB(editAdviceData);
        // To actualise the change
        window.location.reload();
    }

    /**
     * This function handles the new changes made for Advice in New Advice Form.
     * @param _event
     * @param editor
     */
    function handleAdviceChange(_event, editor) {
        let editAdviceDataCopy = JSON.parse(JSON.stringify(editAdviceData));
        editAdviceDataCopy.advice = editor.getData();
        setEditAdviceData(editAdviceDataCopy);
    }

    /**
     * This function handles the new changes made for Category change in New Advice Form.
     * @param newChangeData
     */
    function handleCategoryChange(newChangeData) {
        let editAdviceDataCopy = JSON.parse(JSON.stringify(editAdviceData));
        editAdviceDataCopy.category = newChangeData;
        setEditAdviceData(editAdviceDataCopy);
    }

    function handlePcategoryAddition(selectedItem) {
        let editAdviceDataCopy = JSON.parse(JSON.stringify(editAdviceData));
        editAdviceDataCopy.pcategories.push(selectedItem);
        setEditAdviceData(editAdviceDataCopy);
    }

    function handlePcategoryRemoval(selectedItem) {
        let editAdviceDataCopy = JSON.parse(JSON.stringify(editAdviceData));
        editAdviceDataCopy.pcategories = editAdviceDataCopy.pcategories.filter(cat => cat !== selectedItem);
        setEditAdviceData(editAdviceDataCopy);
    }

    /**
     * This function handles the new changes made for Comments in New Advice Form.
     * @param _event
     * @param editor
     */
    function handleKommentorChange(_event, editor) {
        let editAdviceDataCopy = JSON.parse(JSON.stringify(editAdviceData));
        editAdviceDataCopy.kommentor = editor.getData();
        setEditAdviceData(editAdviceDataCopy);
    }

    /**
     * This function handles the new changes made for Norm in New Advice Form.
     * @param _event
     * @param editor
     */
    function handleNormChange(_event, editor) {
        let editAdviceDataCopy = JSON.parse(JSON.stringify(editAdviceData));
        editAdviceDataCopy.norm = editor.getData();
        setEditAdviceData(editAdviceDataCopy);
    }

    /**
     * This function handles the new changes made for Formel in New Advice Form.
     * @param _event
     * @param editor
     */
    function handleFormelChange(_event, editor) {
        let editAdviceDataCopy = JSON.parse(JSON.stringify(editAdviceData));
        editAdviceDataCopy.formel = editor.getData();
        setEditAdviceData(editAdviceDataCopy);
    }

    /**
     * This function handles the new changes made for Anspruch in New Advice Form.
     * @param newChangeData
     */
    function handleAnspruchChange(newChangeData) {
        let editAdviceDataCopy = JSON.parse(JSON.stringify(editAdviceData));
        editAdviceDataCopy.anspruch = newChangeData;
        setEditAdviceData(editAdviceDataCopy);
    }

    /**
     * This function shows the confirmation model as security check on click on delete button.
     */
    function handleDelete() {
        setEditAdviceDeleteConfirmationModalShow(true);
    }

    /**
     * This function handles the confirmation of deletion for second time. It closes the Confirmation Model and calls API
     */
    async function handleDeleteConfirmationClick() {
        let processedAdviceDataForDeleteAPI = { advices: [{ uidid: editAdviceData.uidid }] };
        setEditAdviceDeleteConfirmationModalShow(false);
        await deleteAdvice(processedAdviceDataForDeleteAPI);
        removeAdviceDB(editAdviceData.uidid);
        window.location.reload();
    }

    async function getPositionCategories() {
        let cat_data = await getKategoriesDataAPI();
        if (cat_data != null) {
            const pcategories = cat_data.map(o => o.category).sort();
            setPcategories(pcategories);
        }
    }

    useEffect(() => {
        if (showEditAdviceModal) {
            getPositionCategories();
        }
    }, [showEditAdviceModal]);

    return (
        <>
            <Button onClick={() => setShowEditAdviceModal(true)} className="handwai-btn-create">
                {' '}
                Edit Advice
            </Button>

            <Modal
                show={showEditAdviceModal}
                onHide={() => onClose()}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Edit Advice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="formEditAdviceID">
                        <Row>
                            <Col md={2} className="col-2">
                                <Form.Label>AdviceID</Form.Label>
                            </Col>
                            <Col m={8}>
                                <Form.Control
                                    as="textarea"
                                    placeholder="advice_id"
                                    className={'adviceIDEditField'}
                                    value={inputAdviceId}
                                    onChange={handleAdviceIdChange}
                                />
                            </Col>
                            {
                                displayOtherFields !== true && (
                                    <Col md={2}>
                                        <Button
                                            size={"sm"}
                                            onClick={() => handleEditClick(inputAdviceId)}>
                                            Find
                                        </Button>
                                    </Col>
                                )
                            }
                        </Row>
                    </Form.Group>

                    {displayOtherFields === true && (
                        <Form>
                            <Form.Group controlId="formEditAdviceID">
                                <Form.Label>Advice</Form.Label>
                                <div>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: ['bold', 'italic']
                                        }}
                                        data={editAdviceData.advice}
                                        onChange={(event, editor) => handleAdviceChange(event, editor)}
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group controlId="formEditCategoryID">
                                <Form.Label>Category</Form.Label>
                                <Form.Control
                                    as="select"
                                    placeholder="new_category_placeholder"
                                    defaultValue={editAdviceData.category}
                                    onChange={(event) => handleCategoryChange(event.target.value)}
                                >
                                    <option selected>Hinweis</option>
                                    <option>Potenzial</option>
                                    <option>Risiko</option>
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="formEditPositionCategoryID">
                                <Form.Label>Reporting Categories</Form.Label>
                                <div id={'advice_category_multiselect'}>
                                    <Multiselect
                                        className={'advice_category_multiselect'}
                                        placeholder={'Neue Kategorie'}
                                        isObject={false}
                                        options={pcategories}
                                        onSelect={(selectedList, selectedItem) => {
                                            handlePcategoryAddition(selectedItem);
                                        }}
                                        onRemove={(selectedList, removeItem) => {
                                            handlePcategoryRemoval(removeItem);
                                        }}
                                        loading={pcategories.length === 0}
                                        avoidHighlightFirstOption={true}
                                        selectedValues={editAdviceData.pcategories}
                                        showCheckbox
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group controlId="formEditKommentorID">
                                <Form.Label>Kommentar</Form.Label>
                                <div>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: ['bold', 'italic']
                                        }}
                                        data={editAdviceData.kommentor}
                                        onChange={(event, editor) => handleKommentorChange(event, editor)}
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group controlId="formEditNormID">
                                <Form.Label>AI-Tag</Form.Label>

                                <div>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: ['bold', 'italic']
                                        }}
                                        data={editAdviceData.norm}
                                        onChange={(event, editor) => handleNormChange(event, editor)}
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group controlId="formEditFormelID">
                                <Form.Label>Formel</Form.Label>

                                <div>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: ['bold', 'italic']
                                        }}
                                        data={editAdviceData.formel}
                                        onChange={(event, editor) => handleFormelChange(event, editor)}
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group controlId="formEditAnspruchID">
                                <Form.Label>Anspruch</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    placeholder="new_anspruch_placeholder"
                                    defaultValue={editAdviceData.anspruch}
                                    onChange={(event) => handleAnspruchChange(event.target.value)}
                                />
                            </Form.Group>

                            <Modal.Footer>
                                <Button
                                    size="lg"
                                    className="btn-lg"
                                    variant="outline-success"
                                    onClick={() => handleSave()}
                                >
                                    <Save />
                                    Speichern
                                </Button>

                                <Button
                                    size="lg"
                                    className="btn-lg"
                                    variant="outline-danger"
                                    onClick={() => handleDelete()}
                                >
                                    <Trash2 />
                                    Löschen
                                </Button>

                                <Button size="lg" className="btn-lg" variant="outline-dark" onClick={() => onClose()}>
                                    <X />
                                    Abbrechen
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Modal.Body>
            </Modal>

            <Modal
                show={editAdviceSaveConfirmationModalShow}
                onHide={() => setEditAdviceSaveConfirmationModalShow(false)}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                animation={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Bitte bestätigen Sie</Modal.Title>
                </Modal.Header>
                <Modal.Body>Möchten Sie die neue Advice wirklich speichern? </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-success" onClick={() => handleSaveConfirmationClick()}>
                        <Check />
                        Ja! Ich bestätige.
                    </Button>
                    <Button variant="outline-dark" onClick={() => setEditAdviceSaveConfirmationModalShow(false)}>
                        <X />
                        Nein
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={editAdviceDeleteConfirmationModalShow}
                onHide={() => setEditAdviceDeleteConfirmationModalShow(false)}
                backdrop="static"
                keyboard={false}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                animation={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Bitte bestätigen Sie</Modal.Title>
                </Modal.Header>
                <Modal.Body>Möchten Sie den Advice wirklich löschen?</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-danger" onClick={() => handleDeleteConfirmationClick()}>
                        <Check />
                        Ja! Ich bestätige.
                    </Button>
                    <Button variant="outline-dark" onClick={() => setEditAdviceDeleteConfirmationModalShow(false)}>
                        <X />
                        Nein
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default EditAdviceComponent;
